import { Button } from "@mixitone/components";
import type { TournamentCompetition } from "@mixitone/models";
import { ApplicationView } from "@mixitone/mvc";
import routeService from "services/RouteService";
import TournamentStandingsController from "./TournamentStandingsController";

interface PrintGroupsButtonProps {
  competition: TournamentCompetition;
  competitionId?: string;
  className?: string;
}

const PrintGroupsButton = ({ competition, className }: PrintGroupsButtonProps) => {
  const controller = TournamentStandingsController.use();
  const hasGroups = Object.keys(controller.state.standingsData?.groups ?? {}).length > 0;

  return (
    <Button
      kind="secondary"
      className={className}
      disabled={!hasGroups || controller.state.loading}
      onClick={() =>
        routeService.openModal("/tournament/:id/competitions/:competitionId/print", {
          params: { id: competition.tournament_session_id!, competitionId: competition.id! },
        })
      }
    >
      Print groups
    </Button>
  );
};

const PrintGroupsButtonView = ApplicationView(PrintGroupsButton);

export default PrintGroupsButtonView;

export const ScopedPrintGroupsButton = TournamentStandingsController.scope(PrintGroupsButtonView);
